import React from "react";
import "./Join.css";
import AppText from "./AppText";
import Links from "./Links";

const JoinSuccess: React.FC = () => {
    return (
        <main>
            <div className="form-wrapper" style={{ textAlign: "center" }}>
                <form className="form">
                    <div className="form-header">
                        <img className="form-header-logo" src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg" alt="MyDataHelps Designer Logo" />
                        <h2>
                            <AppText textKey="join-success-title" />
                        </h2>
                    </div>
                    <p>
                        <AppText textKey="join-success-info" />
                    </p>
                </form>
                <Links forceIsLogin={true} />
            </div>
        </main>
    );
};

export default JoinSuccess;
